module.exports = __webpack_public_path__ + "static/img/template_screenshot-min.07c1349.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/template_screenshot-min.jpg
// module id = +4XV
// module chunks = 1